import { loaderData, updateChecker, popupData } from './state';

export default {
    modules: {
        loaderData,
		updateChecker,
		popupData
    }
};
